import { api } from "../client";
import {
  PartialUserUserAbsenceLimitFields,
  UserUserAbsenceLimitFields,
} from "../schema/UserUserAbsenceLimit";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<UserUserAbsenceLimitFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialUserUserAbsenceLimitFields,
  []
>;

export const getUserUserAbsenceLimits = async (config?: ApiRequestConfig) => {
  return api.get<UserUserAbsenceLimitFields>(
    "user_user_absence_limits",
    config
  );
};
export const getUserUserAbsenceLimit = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<UserUserAbsenceLimitFields>(
    `user_user_absence_limits/${id}`,
    config
  );
};

export const createUserUserAbsenceLimit = (config: ApiRequestConfigMutate) => {
  return api.create<PartialUserUserAbsenceLimitFields>(
    "user_user_absence_limits",
    config
  );
};
export const updateUserUserAbsenceLimit = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialUserUserAbsenceLimitFields>(
    `user_user_absence_limits/${id}`,
    config
  );
};
export const deleteUserUserAbsenceLimit = (id: number) => {
  return api.remove<UserUserAbsenceLimitFields>(
    `user_user_absence_limits/${id}`
  );
};
